import type { JSX, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children: ReactNode;
  vertical?: boolean;
  repeat?: number;
}

export const Marquee = ({
  className,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 2,
}: MarqueeProps): JSX.Element => {
  return (
    <div
      className={cn(
        "group flex overflow-hidden [--duration:40s] [--gap:1rem] [gap:var(--gap)]",
        vertical ? "flex-col" : "flex-row",
        className,
      )}
    >
      {Array.from({ length: repeat }).map((_, i) => (
        <div
          key={i}
          // -v3 suffix: components/home/TestimonialsSection.tsx and
          // components/company-formation/TestimonialSlider.tsx already define
          // their own `.animate-marquee` + `@keyframes marquee` via styled-jsx.
          // Distinct names keep this page's marquee off theirs entirely.
          className={cn("flex shrink-0 justify-around [gap:var(--gap)]", {
            "animate-marquee-v3 flex-row": !vertical,
            "animate-marquee-vertical-v3 flex-col": vertical,
            "group-hover:[animation-play-state:paused]": pauseOnHover,
            "[animation-direction:reverse]": reverse,
          })}
        >
          {children}
        </div>
      ))}
    </div>
  );
};
